// extracted by mini-css-extract-plugin
export default {"tags":"qEmaKnCF","form":"kKKYl7e8","total":"RsxxZVO1"};